/* eslint-disable no-console */
import queue from 'async/queue';
import asyncify from 'async/asyncify';
import CryptoJS from 'crypto-js';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { cloneDeep } from 'lodash';
import { gzipSync } from 'fflate';
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import * as dam from './DAM.service';
import { toasterMsg } from '../Components/Toaster/Toaster';
import { fetchDamList } from '../Pages/DAM/store/DAM.action';
import { localStorageService } from './localStorage.service';
import * as productDam from './dam-product-file.services';
import { fetchProductDamFileList } from '../Pages/DevlopmentOrder/Dam/DamFiles/store/DamFile.action';
import * as customModuleService from './custom-module.services';
import * as SupplierService from './supplier.service';
import * as DevelopmentOrder from './developmentOrder.service';
import { getSlugName, checkArray } from '../Components/helper';
import { logError } from '../utils/logger';
import * as customModuleAction from '../Pages/Library/CustomModule/Store/CustomModule.action';
import * as productCustomModuleAction from '../Pages/DevlopmentOrder/store/DevelopmentOrder.action';
import * as action from '../Pages/Supplier/store/Supplier.action';
import * as productPurchaseOrderAction from '../Pages/DevlopmentOrder/ProductPurchaseOrder/Store/productPurchaseOrder.action';

const ErrorDuringUpload = 'Error during upload: ';
const ErrorInPushFileInQueue = 'Error in pushFileInQueue: ';
const dataIsEmpty = 'Data is empty';
const AwsUploadError = 'CUSTOM_MODULE.ERROR_MESSAGES.AWS_UPLOAD_ERROR';
const ErrorInsideUploadSelectedFile = 'Error inside upload Selected FilesIn Queue push: ';
function generateUniqueId() {
  const randomBytes = CryptoJS.lib.WordArray.random(16);
  return randomBytes.toString(CryptoJS.enc.Hex);
}
const uploadFiles = async (s3PresignedUrl, file, fileData, t, dispatch, onProgress) => {
  try {
    // Detect the content type from the base64 string
    const matches = file.match(/^data:(.*?);base64,/);
    if (!matches || matches.length !== 2) {
      throw new Error('Invalid base64 string');
    }
    const contentType = matches[1]; // Extract the content type

    const base64Data = file.split(',')[1];
    const binaryString = atob(base64Data);
    const len = binaryString.length;
    const buffer = new Uint8Array(len);

    for (const [i, char] of Array.from(binaryString).entries()) {
      buffer[i] = char.charCodeAt(0);
    }

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', s3PresignedUrl, true);
      xhr.setRequestHeader('Content-Type', contentType);
      xhr.setRequestHeader('Content-Encoding', 'base64');
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable && onProgress) {
          const percentCompleted = Math.round((event.loaded / event.total) * 100);
          onProgress(percentCompleted, fileData, t, dispatch);
        }
      };

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.responseURL);
        } else {
          reject(new Error(`Upload failed with status: ${xhr.status}`));
        }
      };

      xhr.onerror = () => reject(new Error('Upload failed'));

      xhr.send(buffer);
    });
  } catch (error) {
    console.error('Error in uploadFiles:', error);
    throw error;
  }
};

const onProgress = (percentCompleted, fileData, t, dispatch) => {
  dispatch({ type: t.UPLOADFILE_PERCENTAGE_STATUS, payload: { filePercentage: percentCompleted, name: fileData.fileName, taskId: fileData.taskId } });
};

// section wise api calls to add data to database after 100 % of file upload
const callApiBasedComponentSection = async (task, componentSection, _t, transactionMsg, params) => {
  try {
    let res = null;
    const cloneTask = { ...task.fileObj };
    if (cloneTask?.croppedImage) {
      cloneTask.croppedImage = cloneTask?.s3ImageCroppedKeyName;
    }
    if (cloneTask?.imageUrl) {
      cloneTask.imageUrl = cloneTask?.s3ImageUrlKeyName;
    }
    if (cloneTask?.videoUrl) {
      cloneTask.videoUrl = cloneTask?.s3VideoUrlName;
    }
    if (cloneTask?.videoThumbnail) {
      cloneTask.videoThumbnail = cloneTask?.s3ThumbnailImageKeyName;
    }
    const isFromLibray = task.moduleName === 'damLibrary';
    const isFromDamProduct = task.moduleName === 'damProduct';

    switch (componentSection) {
      case 'AddDAM':
        if (isFromLibray) {
          res = await dam.saveDamFiles([cloneTask]);
          if (res.code === 200) {
            const msg = transactionMsg(`DAM_MAIN_VIEW.BACKEND_SERVICE.${res.message}`);
            toasterMsg(msg, 'success');
          }
          if (res.code === 500) {
            const msg = transactionMsg(`DAM_MAIN_VIEW.BACKEND_SERVICE.${res.data.errMsg}`);
            toasterMsg(msg, 'danger');
          }
        } else if (isFromDamProduct) {
          res = await productDam.saveProductDamFiles([cloneTask], task.urlDevOrderId);
          if (res.code === 200) {
            const msg = transactionMsg(`PRODUCT_DAM.BACKEND_SERVICE.${res.message}`);
            toasterMsg(msg, 'success');
          }
          if (res.code === 500) {
            const msg = transactionMsg(`PRODUCT_DAM.BACKEND_SERVICE.${res.message}`);
            toasterMsg(msg, 'danger');
          }
        }
        break;
      case 'EditDAM':
        if (isFromLibray) {
          res = await dam.updateDamFiles(cloneTask);
          if (res) {
            const msg = transactionMsg(`DAM_MAIN_VIEW.BACKEND_SERVICE.${res.message}`);
            toasterMsg(msg, 'success');
          }
        } else if (isFromDamProduct) {
          res = await productDam.updateProductDamFiles(cloneTask, task.urlDevOrderId);
          if (res) {
            const msg = transactionMsg(`PRODUCT_DAM.BACKEND_SERVICE.${res.message}`);
            toasterMsg(msg, 'success');
          }
        }

        break;
      case 'DuplicateDAM':
        if (params) {
          const { damId } = params.extraParams;
          res = await dam.duplicateDamFile(cloneTask, damId);
          if (res) {
            const msg = transactionMsg(`DAM_MAIN_VIEW.BACKEND_SERVICE.${res.message}`);
            toasterMsg(msg, 'success');
          }
        }
        break;
      default:
        break;
    }
    return res;
  } catch (err) {
    console.log('Err: callApiBasedComponentSection', err);
    toasterMsg('Api Failed', 'danger');
  }
};

export const getCompressedImage = async (buffer) => {
  try {
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (!userInfo) {
      throw new Error('User is not logged in'); // Handle case where user info is missing
    }
    const config = {
      headers: { Authorization: `Bearer ${userInfo.token}` },
      responseType: 'arraybuffer',
    };
    const response = await axios.post(`${apiEndpoint}${API.S3_URLS.FETCH_COMPRESSED_BUFFER}`, { buffer }, config);
    console.log('responseresponseresponse', response);
    const base64Prefix = 'data:image/jpeg;base64,';
    return base64Prefix + window.btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
  } catch (error) {
    console.error('Error fetching compressed image:', error);
    throw error;
  }
};

export const getPreWriteSignedWriteUrl = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.S3_URLS.WRITE_PRESIGNED_URL}`, {
      params: { ...data },
    });
  } catch (error) {
    logError('Failed to fetch S3 write presigned URL', error);
    throw error;
  }
};

/**
 * Opens an S3 multipart upload and returns { uploadId, objectKey, partSize, partCount }.
 * Used for large files where a single PUT would be slow and unresumable.
 */
export const createMultipartUpload = async (data) => {
  const response = await apiClient.post(`${apiEndpoint}${API.S3_URLS.MULTIPART_CREATE}`, data);
  return response?.data;
};

/** Signs a batch of uploadPart URLs — requested lazily so each URL is used well within its expiry. */
export const signMultipartUploadParts = async (data) => {
  const response = await apiClient.post(`${apiEndpoint}${API.S3_URLS.MULTIPART_SIGN_PARTS}`, data);
  return response?.data;
};

/** Assembles uploaded parts into the final S3 object. */
export const completeMultipartUpload = async (data) => {
  const response = await apiClient.post(`${apiEndpoint}${API.S3_URLS.MULTIPART_COMPLETE}`, data);
  return response?.data;
};

/** Discards an in-flight multipart upload so its parts stop accruing storage cost. */
export const abortMultipartUpload = async (data) => {
  try {
    await apiClient.post(`${apiEndpoint}${API.S3_URLS.MULTIPART_ABORT}`, data);
  } catch (error) {
    logError('Failed to abort multipart upload', error);
  }
};

export const getPreReadSignedWriteUrl = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.S3_URLS.READ_PRESIGNED_URL}`, {
      params: { ...data },
    });
  } catch (error) {
    logError('Failed to fetch S3 read presigned URL', error);
    throw error;
  }
};

/**
 * Proxy-fetch a private S3 object through the BombyxPLM backend and return it as a Blob.
 * The call is same-origin so there are no CORS issues — used for canvas format conversion.
 */
export const getS3FileAsBlob = async (data) => {
  try {
    const response = await apiClient.get(`${apiEndpoint}${API.S3_URLS.PROXY_FILE}`, {
      params: { ...data },
      responseType: 'blob',
    });
    /**
     * The shared response interceptor unwraps successful responses to `response.data`, so a blob
     * request resolves to the Blob itself; the raw AxiosResponse shape is handled as a fallback.
     */
    const blob = response instanceof Blob ? response : response?.data;
    if (!(blob instanceof Blob)) {
      throw new Error('Proxy-fetch did not return a Blob');
    }
    return blob;
  } catch (error) {
    logError('Failed to proxy-fetch S3 object as blob', error);
    throw error;
  }
};

/** Get a short-lived pre-signed URL whose S3 response carries Content-Disposition: attachment. */
export const getDownloadPresignedUrl = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.S3_URLS.DOWNLOAD_PRESIGNED_URL}`, {
      params: { ...data },
    });
  } catch (error) {
    logError('Failed to fetch S3 download presigned URL', error);
    throw error;
  }
};

export const deleteObejctsFromS3 = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.S3_URLS.DELETE_OBJECTS_URL}`, {
      objectKeys: data?.objectKeys,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchYoutubeMetadata = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.S3_URLS.FETCH_YOUTUBE_META_DATA}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchVimeoMetaData = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.S3_URLS.FETCH_VIMEO_META_DATA}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const uploadSelectedFilesInQueue = queue(
  asyncify(
    async ({
      isFromVideoType,
      isFromImageType,
      isCroppedImage,
      isThumbnailImage,
      s3ImageurlPresignedUrl,
      s3VideoPresignedUrl,
      s3ThumbnailImagePresignedUrl,
      s3CroppedImagePresignedUrl,
      fileObj,
      dispatch,
      t,
    }) => {
      try {
        if (isFromImageType) {
          const originalFile = fileObj?.imageUrl;
          console.log('fileObjfileObj', fileObj);
          // create dam function to upload files
          const response = await uploadFiles(s3ImageurlPresignedUrl, originalFile, fileObj, t, dispatch, onProgress);
          console.log('originalFileoriginalFile', originalFile);

          if (response) {
            if (isCroppedImage) {
              dispatch({ type: t.UPDATE_CROPPED_IMAGE_LOADER, payload: { taskId: fileObj.taskId, isCroppedImageLoader: true } });
              const croppedImage = fileObj?.croppedImage;
              console.log('croppedImagecroppedImagecroppedImage', croppedImage);
              const getCompressedBuffer = await getCompressedImage(croppedImage);

              console.log('getCompressedBuffergetCompressedBuffer', getCompressedBuffer);
              const resCropped = await uploadFiles(s3CroppedImagePresignedUrl, getCompressedBuffer, fileObj, t, dispatch, onProgress);
              console.log('resCroppedresCropped', resCropped);
              if (resCropped) {
                dispatch({ type: t.UPDATE_CROPPED_IMAGE_LOADER, payload: { taskId: fileObj.taskId, isCroppedImageLoader: false } });
                return { imageRes: response, croppedRes: resCropped };
              }
            } else {
              return { imageRes: response };
            }
          }
        } else if (isFromVideoType) {
          const originalFile = fileObj?.videoUrl;
          const response = await uploadFiles(s3VideoPresignedUrl, originalFile, fileObj, t, dispatch, onProgress);
          if (response) {
            if (isThumbnailImage) {
              dispatch({ type: t.UPDATE_CROPPED_IMAGE_LOADER, payload: { taskId: fileObj.taskId, isThumbnailImageLoader: true } });
              const croppedImage = fileObj?.videoThumbnail;
              const getCompressedBuffer = await getCompressedImage(croppedImage);
              const resCropped = await uploadFiles(s3ThumbnailImagePresignedUrl, getCompressedBuffer, fileObj, t, dispatch, onProgress);
              if (resCropped) {
                dispatch({ type: t.UPDATE_CROPPED_IMAGE_LOADER, payload: { taskId: fileObj.taskId, isThumbnailImageLoader: false } });
                return { videoRes: response, thumnailRes: resCropped };
              }
            } else {
              return { videoRes: response };
            }
          }
        }
      } catch (error) {
        console.error('Error in uploadSelectedFilesInQueue:', error);
        const deleteKeys = [];
        if (isFromImageType) {
          deleteKeys.push(fileObj?.s3ImageCroppedKeyName);
          deleteKeys.push(fileObj?.s3ImageUrlKeyName);
        } else if (isFromVideoType) {
          deleteKeys.push(fileObj?.s3VideoUrlName);
          deleteKeys.push(fileObj?.s3ThumbnailImageKeyName);
        }
        if (deleteKeys?.length) {
          await deleteObejctsFromS3({ objectKeys: deleteKeys });
        }
        toasterMsg('Uploading Failed', 'danger');
        throw error;
      }
    },
  ),
  2,
);

export const pushFileInQueue = async (task, transactionMsg, params) => {
  const { isFromVideoType, isFromImageType, fileObj, dispatch, t, section, moduleName } = task;

  try {
    await dispatch({ type: t.ADD_FILES_IN_QUEUE_UPLOADER, payload: { [fileObj.taskId]: fileObj } });

    uploadSelectedFilesInQueue.push(task, async (err, data) => {
      try {
        if (!err) {
          // We can call the API from here to save records in the database after 100% completion
          if (data) {
            const response = await callApiBasedComponentSection(task, section, t, transactionMsg, params);
            if (response) {
              if (moduleName === 'damProduct') {
                const localstorageFilter = JSON.parse(localStorage.getItem('damProductFileListFilter'));
                const fileParams = {
                  pageIndex: 1,
                  pageSize: 20,
                  colourTheme: localstorageFilter?.colourTheme,
                  primaryColour: localstorageFilter?.primaryColour,
                  secondaryColour: localstorageFilter?.secondaryColour,
                  folder: localstorageFilter?.folder,
                  fileType: localstorageFilter?.fileType,
                  assetType: localstorageFilter?.assetType,
                  productType: localstorageFilter?.productType,
                  brand: localstorageFilter?.brand,
                  gradingGroups: localstorageFilter?.gradingGroups,
                  category1: localstorageFilter?.category1,
                  category2: localstorageFilter?.category2,
                  category3: localstorageFilter?.category3,
                  category4: localstorageFilter?.category4,
                  dynamicDropdown: localstorageFilter?.dynamicDropdown,
                  devOrderId: fileObj?.devOrderId?._id || fileObj?.devOrderId,
                };
                await dispatch(fetchProductDamFileList(fileParams));
              } else if (moduleName === 'damLibrary') {
                await dispatch(
                  fetchDamList({
                    pageIndex: 1,
                    pageSize: 20,
                  }),
                );
              }
              dispatch({ type: t.REMOVE_TASK_FROM_LIST, payload: fileObj.taskId });
            }
            // Uncomment if you need to check whether all tasks are completed
          }
        }
      } catch (innerError) {
        const deleteKeys = [];
        if (isFromImageType) {
          deleteKeys.push(fileObj?.s3ImageCroppedKeyName);
          deleteKeys.push(fileObj?.s3ImageUrlKeyName);
        } else if (isFromVideoType) {
          deleteKeys.push(fileObj?.s3VideoUrlName);
          deleteKeys.push(fileObj?.s3ThumbnailImageKeyName);
        }
        if (deleteKeys?.length) await deleteObejctsFromS3({ objectKeys: deleteKeys });
        console.error('Error inside uploadSelectedFilesInQueue.push: ', innerError);
      }
    });
  } catch (outerError) {
    console.error(ErrorInPushFileInQueue, outerError);
    const deleteKeys = [];
    if (isFromImageType) {
      deleteKeys.push(fileObj?.s3ImageCroppedKeyName);
      deleteKeys.push(fileObj?.s3ImageUrlKeyName);
    } else if (isFromVideoType) {
      deleteKeys.push(fileObj?.s3VideoUrlName);
      deleteKeys.push(fileObj?.s3ThumbnailImageKeyName);
    }
    if (deleteKeys?.length) await deleteObejctsFromS3({ objectKeys: deleteKeys });
  }
};

export const s3FileName = async (file, section) => {
  const s3FileNameObj = {};
  switch (section) {
    case 'damLibrary':
      if (file?.imageUrl) {
        s3FileNameObj.s3ImageUrlKeyName = `${getSlugName()}/dam/dam_file_original_${generateUniqueId()}`;
      }
      if (file?.croppedImage) {
        s3FileNameObj.s3ImageCroppedKeyName = `${getSlugName()}/dam/dam_file_cropped_${generateUniqueId()}`;
      }
      if (file?.videoUrl) {
        s3FileNameObj.s3VideoUrlName = `${getSlugName()}/dam/video/dam_video_${generateUniqueId()}`;
      }
      if (file?.videoThumbnail) {
        s3FileNameObj.s3VideoThumbnailName = `${getSlugName()}/dam/video/dam_thumbnail_${generateUniqueId()}`;
      }
      return s3FileNameObj;
    case 'damProduct':
      if (file?.imageUrl) {
        s3FileNameObj.s3ImageUrlKeyName = `${getSlugName()}/product_dam/${file.devOrderId}/dam_file_original_${uuidv4()}`;
      }
      if (file?.croppedImage) {
        s3FileNameObj.s3ImageCroppedKeyName = `${getSlugName()}/product_dam/${file.devOrderId}/dam_file_cropped_${uuidv4()}`;
      }
      if (file?.videoUrl) {
        s3FileNameObj.s3VideoUrlName = `${getSlugName()}/product_dam/${file.devOrderId}/video/dam_video_${uuidv4()}`;
      }
      if (file?.videoThumbnail) {
        s3FileNameObj.s3VideoThumbnailName = `${getSlugName()}/product_dam/${file.devOrderId}/video/dam_thumbnail_${uuidv4()}`;
      }
      return s3FileNameObj;
    default:
      return {};
  }
};

// for Custom Module S3 changes
export const s3KeyGenration = async (module, folderId, pageId, devId, supplierId) => {
  switch (module) {
    case 'CustomModule':
      return `${getSlugName()}/Custom_Module_pages/${folderId}/pages_${pageId}`;
    case 'ProductCustomModule':
      return `${getSlugName()}/${devId}/Custom_Module_pages/${folderId}/pages_${pageId}`;
    case 'suppleirTemplate':
      return `${getSlugName()}/partner_overView/${folderId}/pages_${pageId}`;
    case 'suppleirFiles':
      return `${getSlugName()}/suppler_files/${supplierId}/${folderId}/pages_${pageId}`;
    case 'Dpp':
      return `${getSlugName()}/${folderId}`;
    case 'POFiles':
      return `${getSlugName()}/${folderId}/PO_Files/${pageId}/${devId}`;
    default:
      return `${getSlugName()}/`;
  }
};

export const callOriginalApis = async (transactionMsg, params, dispatch) => {
  const dataString = JSON.stringify(params?.dbObject);
  let chunkSuccessful = null;
  if (params?.folderId) {
    chunkSuccessful = await customModuleService.editCustomModuleById({ data: dataString }, params?.folderId);
  } else {
    chunkSuccessful = await customModuleService.insertCustomModule({ data: dataString });
  }
  if (chunkSuccessful?.code === 200) {
    if (params?.folderId) {
      await dispatch(customModuleAction.getCMPageList(params?.folderId));
      const msg = params?.folderId ? transactionMsg(chunkSuccessful.message) : transactionMsg(`CUSTOM_MODULE.${chunkSuccessful.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(`CUSTOM_MODULE.${chunkSuccessful.message}`);
      toasterMsg(msg, 'success');
    }
    return chunkSuccessful?.data;
  }
  const msg = chunkSuccessful.data?.errMsg || 'CUSTOM_MODULE.ERROR_MESSAGES.API_ERROR';
  toasterMsg(transactionMsg(msg?.toString()), 'danger');

  return chunkSuccessful;
};

export const uploadPages = async (s3PreSignedURL, file, transactionMsg) => {
  try {
    // Detect the content type from the base64 string
    const removeS3 = cloneDeep(file);
    if (removeS3.isContectPage === true || checkArray(removeS3.grid)) {
      if (removeS3.s3key) {
        delete removeS3.s3key;
      }
      const compressedPage = gzipSync(new TextEncoder().encode(JSON.stringify(removeS3)));
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', s3PreSignedURL, true);
        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            resolve(xhr.responseURL);
          } else {
            reject(new Error(`Upload failed with status: ${xhr.status}`));
          }
        };
        xhr.onerror = () => reject(new Error('Upload failed'));
        xhr.send(compressedPage);
      });
    }
  } catch (error) {
    console.error('Error in uploadFiles:', error);
    toasterMsg(transactionMsg(AwsUploadError), 'danger');
    throw error;
  }
};

export const uploadPagesInQueue = queue(
  asyncify(async ({ s3PreSignedURL, file, transactionMsg, section }) => {
    try {
      if (section === 'Dpp') {
        return new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open('PUT', s3PreSignedURL, true);
          xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
              resolve(xhr.responseURL);
            } else {
              reject(new Error(`Upload failed with status: ${xhr.status}`));
            }
          };
          xhr.onerror = () => reject(new Error('Upload failed'));
          xhr.send(file);
        });
      }
      if (section === 'POFiles') {
        return new Promise((resolve, reject) => {
          if (!(file instanceof Blob) || file.size === 0) {
            console.error('uploadPagesInQueue POFiles: refusing to upload non-Blob or empty file', {
              isBlob: file instanceof Blob,
              size: file?.size,
              type: file?.type,
              name: file?.name,
            });
            reject(new Error('Refusing to upload: file is not a Blob or is empty'));
            return;
          }
          const xhr = new XMLHttpRequest();
          xhr.open('PUT', s3PreSignedURL, true);
          const contentType = file.type || 'application/octet-stream';
          xhr.setRequestHeader('Content-Type', contentType);
          xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
              resolve(xhr.responseURL);
            } else {
              reject(new Error(`Upload failed with status: ${xhr.status}`));
            }
          };
          xhr.onerror = () => reject(new Error('Upload failed'));
          xhr.send(file);
        });
      }
      const response = await uploadPages(s3PreSignedURL, file, transactionMsg);
      if (response) {
        return response;
      }
    } catch (error) {
      console.error('Error in uploadSelected Files InQueue:', error);
      throw error;
    }
  }),
  2,
);

export const pushPageUpdateInQueue = async (task, transactionMsg, params) => {
  const { s3PreSignedURL, file, dispatch } = task; // needed for removal of the s3
  return new Promise((resolve, reject) => {
    try {
      uploadPagesInQueue.push({ s3PreSignedURL, file, transactionMsg }, async (err, data) => {
        try {
          if (err) {
            console.log(ErrorDuringUpload, err);
            reject(new Error(transactionMsg(AwsUploadError)));
          } else {
            // We can call the API from here to save records in the database after 100% completion
            if (data) {
              if (params?.devOrderId) {
                const result = await callProductOriginalApis(transactionMsg, params, dispatch);
                resolve(result);
              } else {
                const result = await callOriginalApis(transactionMsg, params, dispatch);
                resolve(result);
              }
            } else {
              console.log(dataIsEmpty);
              resolve(null); // Or handle empty data case accordingly
            }
          }
        } catch (innerError) {
          console.error(ErrorInsideUploadSelectedFile, innerError);
          reject(innerError);
        }
      });
    } catch (outerError) {
      console.error(ErrorInPushFileInQueue, outerError);
      reject(outerError);
    }
  });
};

// call product level CM APIs
export const callProductOriginalApis = async (transactionMsg, params, dispatch) => {
  const dataString = JSON.stringify(params?.dbObject);
  const chunkSuccessful = await DevelopmentOrder.saveCustomModule({ data: dataString }, params?.folderId);
  if (chunkSuccessful?.code === 200) {
    await dispatch(productCustomModuleAction.getProductCMPageList(params?.devOrderId, params?.folderId));
    const msg = params?.devOrderId ? transactionMsg(`DEVELOPMENT_ORDER.${chunkSuccessful?.message}`) : transactionMsg(`${chunkSuccessful?.message}`);
    toasterMsg(msg, 'success');
    return chunkSuccessful?.data;
  }
  const msg = chunkSuccessful.data?.errMsg;
  toasterMsg(msg.toString(), 'danger');

  return chunkSuccessful;
};

export const pushSupplierPageUpdateInQueue = async (task, transactionMsg, params) => {
  const { s3PreSignedURL, file, dispatch } = task; // needed for removal of the s3

  return new Promise((resolve, reject) => {
    try {
      uploadPagesInQueue.push({ s3PreSignedURL, file, transactionMsg }, async (err, data) => {
        try {
          if (err) {
            console.log(ErrorDuringUpload, err);
            reject(new Error(transactionMsg(AwsUploadError)));
          } else {
            // We can call the API from here to save records in the database after 100% completion
            if (data) {
              const result = await callSupplierTemplateOriginalApis(transactionMsg, params, dispatch);
              resolve(result);
            } else {
              console.log(dataIsEmpty);
              resolve(null); // Or handle empty data case accordingly
            }
          }
        } catch (innerError) {
          console.error(ErrorInsideUploadSelectedFile, innerError);
          reject(innerError);
        }
      });
    } catch (outerError) {
      console.error(ErrorInPushFileInQueue, outerError);
      reject(outerError);
    }
  });
};

export const callSupplierTemplateOriginalApis = async (transactionMsg, params, dispatch) => {
  const dataString = JSON.stringify(params?.dbObject);
  let chunkSuccessful = null;
  if (params?.folderId) {
    chunkSuccessful = await SupplierService.editSupplierTemplateById({ data: dataString }, params?.folderId);
  } else {
    chunkSuccessful = await SupplierService.insertSupplierTemplate({ data: dataString });
  }
  if (chunkSuccessful?.code === 200) {
    if (params?.folderId) {
      await dispatch(action.getCMPageList(params?.folderId));
      const msg = transactionMsg(`PARTNER_OVERVIEW.${chunkSuccessful.message}`);
      toasterMsg(msg, 'success');
    }
    return chunkSuccessful?.data;
  }
  const msg = transactionMsg(chunkSuccessful.data?.errMsg);
  toasterMsg(msg.toString(), 'danger');

  return chunkSuccessful;
};

export const callSupplierFilesOriginalApis = async (transactionMsg, params, templateId, dispatch) => {
  const dataString = JSON.stringify(params?.dbObject);
  let chunkSuccessful = null;
  if (params?.folderId) {
    chunkSuccessful = await SupplierService.updateDocTemplatewithDocumentId({ data: dataString }, params?.folderId);
    await dispatch(action.getFilesPageList(params?.folderId));
  } else {
    chunkSuccessful = await SupplierService.saveSupplierDocumentTemplate({ data: dataString }, templateId);
  }
  if (chunkSuccessful?.code === 200) {
    const msg = transactionMsg(`SUPPLIER_DOCUMENT.${chunkSuccessful.message}`);
    toasterMsg(msg, 'success');
    return chunkSuccessful?.data;
  }
  const msg = transactionMsg(chunkSuccessful.data?.errMsg);
  toasterMsg(msg.toString(), 'danger');
  return chunkSuccessful;
};

export const pushSupplierFilesPageUpdateInQueue = async (task, transactionMsg, params) => {
  const { s3PreSignedURL, file, dispatch } = task; // needed for removal of the s3
  return new Promise((resolve, reject) => {
    try {
      uploadPagesInQueue.push({ s3PreSignedURL, file, transactionMsg }, async (err, data) => {
        try {
          if (err) {
            console.log(ErrorDuringUpload, err);
            throw new Error(transactionMsg(AwsUploadError));
          } else {
            // We can call the API from here to save records in the database after 100% completion
            if (data) {
              const result = await callSupplierFilesOriginalApis(transactionMsg, params, '', dispatch);
              resolve(result);
            }
          }
        } catch (innerError) {
          console.error(ErrorInsideUploadSelectedFile, innerError);
          reject(innerError);
        }
      });
    } catch (outerError) {
      console.error(ErrorInPushFileInQueue, outerError);
      reject(outerError);
    }
  });
};

export const deleteDPPObejctsFromS3 = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.S3_URLS.DELETE_OBJECTS_URL}`, {
      objectKeys: data?.objectKeys,
    });
  } catch (dppError) {
    console.error(dppError);
    throw dppError;
  }
};

export const pushDppPageinQueue = async (task, transactionMsg) => {
  const { s3PreSignedURL, file, section } = task; // needed for removal of the s3
  return new Promise((resolve, reject) => {
    try {
      uploadPagesInQueue.push({ s3PreSignedURL, file: file.files, transactionMsg, section }, async (err, data) => {
        try {
          if (err) {
            console.log(ErrorDuringUpload, err);
            reject(new Error(transactionMsg(AwsUploadError)));
          } else {
            transactionMsg('Uploaded Successfully');
            resolve(true);
          }
        } catch (innerError) {
          console.error(ErrorInsideUploadSelectedFile, innerError);
          reject(innerError);
        }
      });
    } catch (outerError) {
      console.error(ErrorInPushFileInQueue, outerError);
      reject(outerError);
    }
  });
};

export const callPoFilesOriginalApis = async (transactionMsg, params, dispatch) => {
  try {
    // Call the action following project patterns
    const result = await dispatch(productPurchaseOrderAction.createPurchaseOrderFile(params));

    if (result?.code === 200) {
      return result.data;
    }
    throw new Error(result?.message || 'Failed to save file metadata');
  } catch (error) {
    console.error('Error in callPoFilesOriginalApis:', error);
    // Error message is already handled in the action
    throw error;
  }
};

export const uploadPoFilesToS3 = async (task, transactionMsg) => {
  const { s3PreSignedURL, file, dispatch } = task; // needed for removal of the s3
  return new Promise((resolve, reject) => {
    try {
      uploadPagesInQueue.push({ s3PreSignedURL, file, transactionMsg, section: 'POFiles' }, async (err, data) => {
        try {
          if (err) {
            console.log(ErrorDuringUpload, err);
            throw new Error(transactionMsg(AwsUploadError));
          } else if (data) {
            const result = await callPoFilesOriginalApis(transactionMsg, { ...task.params }, dispatch);
            resolve(result);
          }
        } catch (innerError) {
          console.error(ErrorInsideUploadSelectedFile, innerError);
          reject(innerError);
        }
      });
    } catch (outerError) {
      console.error(ErrorInPushFileInQueue, outerError);
      reject(outerError);
    }
  });
};
